import * as React from 'react'

import { IProps } from './types'

const ShouldRender: React.FunctionComponent<IProps> = ({ onlyIf, render }) => (onlyIf ? render : null)

export default ShouldRender
